import React from 'react';

import styled from 'styled-components';

import { Carousel } from '@zanichelli/react-components';

const Quote = styled.div`
    height: 256px;
    max-width: 512px;
    margin: 32px auto;

    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;

    background-image: url('/_assets/images/landingV2/double_quotes.svg');
    background-repeat: no-repeat;
    background-size: 96px;
    background-position-x: center;
    background-position-y: 16px;
`;

const Text = styled.div`
    font-size: 24px;
    text-align: center;
    margin: 32px;

    @media screen and (max-width: 767px) {
        margin: 16px;
    }

    @media screen and (min-width: 768px) and (max-width: 1365px) {
        margin: 24px;
    }
`;

const BottomText = styled.div`
    text-align: center;
`;

const User = styled.div`
    font-size: 18px;
    font-weight: 600;
`;

const Role = styled.div`
    font-size: 16px;
    font-style: italic;
`;

const quotes = [
    {
        text: 'Mi facilita il lavoro perché permette di creare una verifica ben strutturata in poco tempo, attingendo da tanti libri',
        user: 'Marta',
        role: 'Insegnante di matematica superiori'
    },
    {
        text: 'Molto pratico perché non si devono riscrivere testi: si trova una vasta gamma di esercizi che rispecchiano l’attività svolta in classe',
        user: 'Federico',
        role: 'Insegnante di inglese superiori'
    },
    {
        text: 'Comodo e utile soprattutto perché si possono generare fino a quattro file con in aggiunta la versione ad alta leggibilità!',
        user: 'Anna',
        role: 'Insegnante di lettere medie'
    }
];

const Div = styled.div`
    display: flex;
`;

const Quotes = () => {
    const Container = window.innerWidth < 1366 ? Carousel : Div;

    return (
        <Container>
            {quotes.map((quote, index) => (
                <Quote key={index}>
                    <Text>{`“${quote.text}”`}</Text>
                    <BottomText>
                        <User>{quote.user}</User>
                        <Role>{quote.role}</Role>
                    </BottomText>
                </Quote>
            ))}
        </Container>
    );
};

export default Quotes;
